import PropTypes from "prop-types";
import React from "react";

class CloseSidebar extends React.Component {
  static get propTypes() {
    return {
      hideSidebar: PropTypes.func.isRequired,
      location: PropTypes.object.isRequired,
    };
  }

  shouldComponentUpdate(nprops) {
    const { location } = nprops;

    return this.props.location.pathname !== location.pathname;
  }

  componentDidUpdate() {
    const { hideSidebar } = this.props;

    hideSidebar();
  }

  render() {
    return null;
  }
}

export { CloseSidebar };
